"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMatchMedia = useMatchMedia;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _environment = require("./environment");
/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


function useMatchMedia(mediaQueryString) {
  var _useState = (0, _react.useState)(function () {
    if (_environment.canUseDOM) {
      var mediaQueryList = window.matchMedia(mediaQueryString);
      return mediaQueryList.matches;
    }

    return false;
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  (0, _react.useEffect)(function () {
    function listener(event) {
      setMatches(event.matches);
    }

    var mediaQueryList = window.matchMedia(mediaQueryString);
    mediaQueryList.addEventListener('change', listener); // Make sure the media query list is in sync with the matches state

    setMatches(mediaQueryList.matches);
    return function () {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [mediaQueryString]);
  return matches;
}